import styled from '@emotion/styled';

export const StyledContent = styled.div(() => ({
    width: 'fit-content',
    maxWidth: 580,
    margin: '15px auto',
}));
